import { render, staticRenderFns } from "./TrademarkWipoXmlForm.vue?vue&type=template&id=2c5195e0&"
import script from "./TrademarkWipoXmlForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkWipoXmlForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkWipoXmlForm.vue?vue&type=style&index=0&id=2c5195e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports